import React from "react";
import logo from "../../../assets/logo2.png";
import { ChevronLeftOutlined, ChevronRightOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import GlobalContext from "../../../context/GlobalCalendarContext";

export default function CalendarHeader() {
  const { monthIndex, setMonthIndex } = React.useContext(GlobalContext);
  function handlePrevMonth() {
    setMonthIndex(monthIndex - 1);
  }

  function handleNextMonth() {
    setMonthIndex(monthIndex + 1);
  }

  function handleReset() {
    setMonthIndex(dayjs().month());
  }

  return (
    <header className="px-4 mb-2 flex items-center">
      <img src={logo} alt="logo" className="w-10 h-10 mr-2 " />
      <h1 className="mr-10 text-xl text-gray-500 font-bold">Calendar</h1>
      <button onClick={handleReset} className="border rounded py-2 px-4 mr-5">
        Today
      </button>
      <button onClick={handlePrevMonth}>
        <span className=" material-icons-outlined cursor-pointer text-gray-600 mx-2">
          <ChevronLeftOutlined />
        </span>
      </button>
      <button onClick={handleNextMonth}>
        <span className="cursor-pointer text-gray-600 mx-2">
          <ChevronRightOutlined />
        </span>
      </button>
      <h2 className="ml-4 text-xl text-gray-500 font-bold">
        {dayjs(new Date(dayjs().year(), monthIndex)).format("MMMM YYYY")}
      </h2>
    </header>
  );
}
